import { DataStatus } from '@onepercentio/one-ui/components/Form/Form.types'
import { PERSONAL_DATA_FIELDS } from 'context/FlowPrerequirements'
import { OfferType } from 'core/logic/drop/drop.types'
import { PrereqTo } from 'features/FlowPrerequirements/StandalonePrereq/StandalonePrereq.types'
import Styles from 'openspace/assets/styles/TextStyles.module.scss'
import { MenuOptions } from 'openspace/components/TopBar/TopBar.types'
import { AvailableConcepts } from 'openspace/pages/Authenticated/Home/v2/Home/Features/Features'
import { TrackingStatus } from 'openspace/pages/Authenticated/Tracking/Tracking.types'
import { IPO_SECTIONS } from 'pages/Unauthenticated/Drops/Details/Models/IPO/IPO.view'

export type ConceptTranslations = {
  [F in AvailableConcepts]: {
    title: string
    description: string
    features: string[]
  }
}

type TRACKING_STATUS = {
  label: {
    [s in TrackingStatus]: string
  }
  detail: {
    [s in Exclude<TrackingStatus, 'PAYED'>]: string
  } & {
    TRACKING_INFO: string
    TRACKING_N_CONTACT: string
  }
}

const messages = {
  'pt-BR': {
    translations: {
      flowRequirements: {
        steps: {
          personalData: {
            title: 'Dados pessoais',
            questions: {
              name: 'Nome completo',
              email: 'Email',
              birthDate: 'Data de nascimento',
              phone: 'Telefone (Com DDD)',
              document: 'CPF',
              documentForeign: 'Documento',
              isForeign: '',
              confirm:
                'Aceito compartilhar meus dados com <b>({{gallery}})</b> para fins de marketing',
            } satisfies {
              [k in PERSONAL_DATA_FIELDS]: string
            } & {
              [k in 'documentForeign' | 'isForeign' | 'confirm']: string
            },
            error: {
              invalidCPF: 'Documento inválido',
            },
          },
          address: {
            title: 'Endereço',
          },
          kyc: {
            title: 'Validação dos dados',
            loading: 'Estamos validando seus dados',
            rejected: {
              title: 'ops, algo deu errado',
              description: 'Verifique seus dados com atenção e tente novamente',
            },
            approved: {
              title: 'Tudo certo!',
              description: 'Seus dados foram validados!',
            },
            progress: {
              sendingData: 'Iniciando a validação dos seus dados',
              waitingReturn:
                'Aguardando confirmação dos dados, você pode deixar essa tela se precisar.',
            },
          },
        },
        standalone: {
          hi: 'Olá, {{name}}',
          to: {
            claim: {
              title: 'Complete o cadastro para continuar com o resgate',
              action: 'Resgatar',
              loading: 'Por favor aguarde, estamos encaminhando para o resgate',
            },
            'marketplace-buy': {
              title: 'Complete os dados a seguir para seguir com a verificação',
              action: '$t(generic.continue)',
              loading: 'Por favor aguarde',
            },
            'marketplace-sell': {
              title: '$t(flowRequirements.standalone.to.marketplace-buy.title)',
              action:
                '$t(flowRequirements.standalone.to.marketplace-buy.action)',
              loading:
                '$t(flowRequirements.standalone.to.marketplace-buy.loading)',
            },
          } as {
            [t in PrereqTo]: {
              title: string
              action: string
              loading: string
            }
          },
        },
      },
      generic: {
        noItemsFound: 'Nenhum item encontrado',
        brandMotto: 'Isso é raro. Isso é Rarum.',
        knowMore: 'Saiba mais',
        waitingAuthorization: 'Aguardando confirmação',
        actions: {
          copy: 'Copiar',
        },
      },
      forum: {
        postedAt: 'Postado {{time}} atrás',
        noItems:
          'Está com dúvidas? \nUtilize o campo acima e seja o primeiro a perguntar',
        post: {
          placeholder: 'Escreva sua dúvida aqui',
          cancelConfirmation: 'Deseja descartar a mensagem escrita?',
          loggedOutUser: 'Olá, é necessário login para interagir',
          actions: {
            cancel: 'Cancelar',
            post: 'Postar',
          },
        },
        actions: {
          reply: 'Responder',
        },
      },
      offerDetails: {
        goal: 'Meta',
        face: 'Valor de face',
        minInvestment: 'Preço por quota',
        minInvestmentShort: 'Preço p. quota',
        investors: 'Investidores',
        reachedPrice: 'Total captado',
        beTheFirstToInvest: 'Seja o 1º a investir',
        receivable: {
          soldUnits: 'Total vendido',
          availability: 'Disponibilidade',
          expiration: 'Vencimento',
          integralization: 'Data integralização',
          sold: 'Vendido',
        },
        cvm: {
          quotas: "Total de {{count}} quotas",
          availableQuotas: "({{count}} quotas restantes)",
          rentability: "Rentabilidade",
          performance: '{{performance}}% a.a.',
          types: {
            equity: 'Equity',
            fixed: 'Renda fixa',
            receivable: 'Recebíveis',
          } satisfies {
            [k in OfferType['cvm88']['type']]: string
          },
        },
        goalReached: '{{percent}}% da meta alcançada',
        goalReached_0: 'Sem quotas reservadas',
        goalReached_beyond: 'Meta alcançada',
        sold: '{{percent}}% vendido',
        sold_0: 'Sem vendas',
        sold_beyond: 'Meta alcançada',
        limit: 'Limite',
        timeRemaining: 'TEMPO RESTANTE',
        offer: 'OFERTA',
        preMoneyValuation: 'VALUATION',
        companyParticipation: 'participação da empresa',
        sections: {
          ABOUT: 'Sobre o investimento',
          DOCUMENTS: 'Documentos',
          KPI: "KPI's",
          FOUNDERS: 'Fundadores',
          FORUM: 'Forum',
        } satisfies {
          [k in keyof typeof IPO_SECTIONS]: string
        },
        forum: {
          description:
            'Acesse o forum para conversar e tirar dúvidas com outros investidores e especialistas',
          posts: 'Postagens',
          actions: {
            access: 'Acessar Forum',
          },
          error: {
            signin: 'Você precisa estar autenticado para visualizar essa seção',
            cvm: {
              pending:
                'Estamos analisando seu perfil. Por favor aguarde. Você recebrá atualizações pelo email.',
              required: 'Você precisa completar seu perfil para prosseguir',
              actions: {
                goToCVM: 'Realizar verificação',
              },
              rejected:
                'Seu perfil não foi aceito. Verifique o email para mais detalhes.',
            },
          },
        },
        actions: {
          invest: 'Investir',
          seeProfile: 'Ver perfil no {{social}}',
          moreInfo: 'Mais informações',
        },
      },
      components: {
        drop: {
          soldout: 'Unidades esgotadas',
          remaining: 'Último item disponível',
          remaining_plural: '{{count}} unidades disponíveis',
        },
        benefits: {
          title: 'Benefícios',
          subtitle: 'Veja e gerencie seus benefícios',
          claim: 'Resgatar',
          expired: 'Benefício expirado',
          claiming: 'Resgatando benefício',
          claimed: 'Benefício resgatado',
          expireIn: 'Expira em:',
          days_plural: '{{count}} dias',
          days: '{{count}} dia',
          remaining: '{{count}} unidade restante',
          remaining_plural: '{{count}} unidades restantes',
          claimConfirmation: {
            details: {
              title: 'Detalhe do benefício',
              details: 'Mais detalhes',
              actions: {
                claim: 'Resgatar benefício',
              },
            },
            title: 'Confirmar resgate',
            actions: {
              claim: 'Resgatar',
            },
            success: {
              title: 'Coleta confirmada!',
              subtitle:
                'Você tem certeza que deseja resgatar esse benefício? <br/>Essa ação não poderá ser desfeita',
              description:
                'Em breve você receberá instruções e mais informações sobre essa coleta no seu email cadastrado {{email}}',
              pending:
                'Esta transação pode levar alguns minutos. Assim que confirmado o resgate, você receberá instruções e mais informações no seu email cadastrado <b>{{email}}</b>',
              actions: {
                understood: 'Entendi',
              },
            },
          },
        },
        form: {
          dataStatus: {
            COMPLETE: 'Concluído',
            INCOMPLETE: 'Incompleto',
            PENDING: 'Pendente',
            ERROR: 'Com erro',
          } satisfies {
            [status in keyof typeof DataStatus]: string
          },
        },
        galleryCard: {
          tokenEmitter: {
            totalVolume: 'Volume total',
            projects: '{{count}} projeto',
            projects_plural: '{{count}} projetos',
          },
        },
      },
      home: {
        banner: {
          title: `ATIVOS DIGITAIS <br/><span class="${Styles.gradient}">SUSTENTÁVEIS E PARA <br/>TODOS</span>`,
          subtitle:
            'Mercado de ativos tokenizados customizados para a sua comunidade',
          action: {
            create: 'Crie agora sua loja!',
          },
          v2: {
            brand: 'rarum',
            brandMotto: 'Community Engagement as a Service',
            brandBenefit: 'Nós valorizamos o que é raro: sua comunidade.',
            actions: {
              features: 'Conheça nossa plataforma Whitelabel',
            },
          },
        },
        sections: {
          highlights: {
            title: 'Ofertas abertas',
          },
          gallery: {
            heading: 'Conheça as Galerias da Rarum',
            title: 'Últimas galerias',
            action: {
              seeAll: 'Ver todas galerias',
            },
          },
          latest: {
            title: 'Últimas ofertas',
            action: {
              seeAll: 'Ver todos itens',
            },
          },
          store: {
            title: 'Lojas',
          },
          brand: {
            title: '100% Carbon Neutral',
            description: `Compensamos todas as emissões de carbono da plataforma e dos ativos comercializados.

A Rarum também opera em blockchains que são eficientes nas suas emissões de gás de efeito estufa.`,
          },
          create: {
            title:
              'Crie sua própria galeria ou loja e comece a vender seus itens!',
            actions: {
              knowMore: 'Saiba mais',
            },
            highlight: {
              create: 'Crie seus ativos digitais',
              easy: 'Fácil para comprar e vender',
              secure: 'Segura, transparente e carbono neutro',
            },
          },
          partnership: {
            title: 'Carbono Neutro',
            description:
              'Em nossa busca por práticas mais sustentáveis, reduzimos significativamente nossas emissões de carbono e implementamos tecnologias blockchain de baixo impacto ambiental.',
            actions: {
              knowMore: 'Saiba mais',
            },
          },
          news: {
            title: 'Notícias',
          },
        },
      },
      allGalleries: {
        title: 'GALERIAS',
        sections: {
          highlight: {
            title: 'Galerias em destaque',
          },
          createYourOwn: {
            title:
              'Crie sua própria galeria ou loja e comece a vender seus ativos digitais!',
            action: {
              knowMore: 'Saiba mais',
            },
          },
        },
      },
      myCollection: {
        actions: {
          seeAllGallery: 'Ver todos',
          hideAllGallery: 'Voltar a lista',
        },
      },
      galleryDetails: {
        items: 'Ofertas ativas',
        expiredItems: 'Ofertas encerradas',
        market: 'Itens do mercado',
        noMarket: 'Itens da galeria',
        noAvailable: `Fique de olho!
Em breve teremos ofertas ativas nesta galeria`,
        actions: {
          seeAllMarketplace: 'Ver todos no mercado',
          seeAll: 'Ver todos os items',
        },
      },
      topbar: {
        menus: {
          [MenuOptions.ABOUT]: 'SOBRE A RARUM',
          [MenuOptions.FAQ]: 'FAQ',
          [MenuOptions.GALLERIES]: 'GALERIAS',
          [MenuOptions.MARKET]: 'MERCADO',
          [MenuOptions.HOW_IT_WORKS]: 'COMO FUNCIONA',
          [MenuOptions.BRAND]: 'MARCAS',
          [MenuOptions.CREATORS]: 'CRIADORES',
        } satisfies {
          [k in MenuOptions]: string
        },
        auth: {
          login: 'Acessar conta',
          signup: 'Cadastre-se',
        },
      },
      offer: {
        creation: {
          steps: {
            value: {
              price: {
                reference: 'Valor referência',
                min: 'Valor mínimo',
                max: 'Valor máximo',
              },
              cut: 'Percentual da plataforma',
              receive: 'Você vai receber',
            },
            payment: {
              disclaimer:
                'No momento só é possível comprar e vender no mercado secundário através do PIX',
              description: 'Você recebe o valor após a entrega concluída',
              pix: {
                title: 'CHAVE PIX',
                description:
                  'Informe a chave PIX que você deseja receber o valor do anúncio',
                placeholder: 'CPF, email, celular ou chave PIX',
                disclaimer:
                  'A chave PIX informada deve ser do mesmo titular da conta, informado na confirmação dos dados financeiros',
                error: {
                  invalid:
                    'A chave inserida não corresponde ao CPF cadastrado. Verifique os dados e tente novamente.',
                },
              },
            },
            address: {
              title: 'Endereço de origem do item',
              description:
                'Confirme ou adicione um endereço de origem para postagem do item após a compra',
              actions: {
                addAddress: 'Adicionar endereço',
              },
            },
            delivery: {
              title: 'Pontos de coleta mais próximos',
              actions: {
                enableLocation: 'Encontrar próximos',
              },
            },
            deliveryConfirmation: {
              origin: {
                title: 'Endereço de origem do item',
                description:
                  'Confirme o endereço de origem e veja a transportadoras próximas para postagem do item após a compra',
              },
              postoffices: {
                title: 'Transportadoras próximas',
                description:
                  'Veja as transportadoras próximas do endereço informado',
                action: {
                  seeOnMap: 'Ver mapa',
                },
              },
            },
            confirmation: {
              title:
                'Ao clicar em enviar anúncio você confirma que está de acordo com os {{termsAction}}',
            },
            creating: {
              title: 'Publicando anúncio',
              routeChangeWarning: `O anúncio ainda não foi publicado. Ao sair a criação pode não ser concluída.
Tem certeza que deseja sair?`,
              progress: {
                authorizing: 'Permitindo a movimentação do item',
                creatingOffer: 'Criando a oferta',
              },
            },
            created: {
              title: 'Anúncio publicado com Sucesso!',
              description:
                'Gerencie e visualize seus anúncios na área “$t(pages.collections.tab.offers)”, dentro da seção “$t(components.router.tabs.closet)”',
            },
          },
        },
        buy: {
          steps: {
            address: {
              title: 'Endereço de entrega',
            },
          },
          loading: 'Estamos preparando seu pedido',
          progress: {
            authorizing: 'Permitindo a movimentação financeira',
            buyingOffer: 'Criando pedido',
          },
        },
      },
      tracking: {
        total: 'Total',
        number: 'Número do Pedido',
        currentStatusTag: 'Situação atual',
        heading: {
          failed: 'Entrega falhou',
        },
        status: {
          title: 'Situação do pedido',
          seller: {
            label: {
              AWAITING_POST: '$t(tracking.status.buyer.label.AWAITING_POST)',
              PROCESSED: 'Objeto postado',
              IN_TRANSIT: '$t(tracking.status.buyer.label.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.label.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.label.DELIVERED)',
              FAILED_AWAIT: '$t(tracking.status.buyer.label.FAILED_AWAIT)',
              DELIVERY_FAILED:
                '$t(tracking.status.buyer.label.DELIVERY_FAILED)',
              FAILED_COLLECT: '$t(tracking.status.buyer.label.FAILED_COLLECT)',
              FAILED_CONTACT: '$t(tracking.status.buyer.label.FAILED_CONTACT)',
              FAILED_RETURN: '$t(tracking.status.buyer.label.FAILED_RETURN)',
              PAYED: '$t(tracking.status.buyer.label.PAYED)',
            },
            detail: {
              TRACKING_INFO: '$t(tracking.status.buyer.detail.TRACKING_INFO)',
              TRACKING_N_CONTACT:
                '$t(tracking.status.buyer.detail.TRACKING_N_CONTACT)',
              AWAITING_POST: `Agora é só copiar o código abaixo, levar até uma agência mais próxima dos Correios e realizar a postagem.$t(tracking.status.seller.detail.TRACKING_INFO)`,
              PROCESSED: '$t(tracking.status.buyer.detail.PROCESSED)',
              IN_TRANSIT: '$t(tracking.status.buyer.detail.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.detail.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.detail.DELIVERED)',
              DELIVERY_FAILED: 'Tivemos um problema na entrega.',
              FAILED_COLLECT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_CONTACT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_RETURN:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_AWAIT: '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
            },
          } satisfies TRACKING_STATUS,
          buyer: {
            label: {
              AWAITING_POST: 'Aguardando envio',
              PROCESSED: 'Objeto postado pelo vendedor',
              IN_TRANSIT: 'Objeto Em trânsito',
              OUT_FOR_DELIVERY: 'Objeto Saiu para entrega ao destinatário',
              DELIVERED: 'Objeto entregue',
              FAILED_AWAIT: 'Falha na tentativa de Entrega',
              DELIVERY_FAILED: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_COLLECT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_CONTACT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_RETURN: 'Retornando para o vendedor',
              PAYED: 'Pagamento realizado',
            },
            detail: {
              TRACKING_INFO: `\n\nCódigo de rastreio:
{{trackingCode}}

{{trackBtn}}`,
              TRACKING_N_CONTACT: `\n\nCódigo de rastreio:
{{trackingCode}}

{{contactBtn}}`,
              AWAITING_POST: `Seu pedido foi confirmado!
  O vendedor fará o envio em até 7 dias úteis
  
  Você receberá uma notificação assim que o pedido for enviado.`,
              PROCESSED: `Previsão de entrega: {{- predictedDeliveryDate}}$t(tracking.status.buyer.detail.TRACKING_INFO)`,
              IN_TRANSIT: '$t(tracking.status.buyer.detail.PROCESSED)',
              OUT_FOR_DELIVERY: `Código de rastreio dos Correios:
  {{trackingCode}}`,
              DELIVERED: `Chegou em {{- deliveryDate}}$t(tracking.status.buyer.detail.TRACKING_INFO)`,
              DELIVERY_FAILED: `Aguarde a próxima tentativa de entrega, que será feita no próximo dia útil
  Se o carteiro não for atendido em nenhuma das tentativas, o objeto será encaminhado para a unidade dos Correios.$t(tracking.status.buyer.detail.TRACKING_INFO)`,
              FAILED_COLLECT: `Seu pedido está disponível para retirada nos Correios
  Entre em contato com os Correios para mais informações.$t(tracking.status.buyer.detail.TRACKING_INFO)`,
              FAILED_CONTACT: `Algo deu errado com a sua entrega.
  Entre em contato com nosso suporte para mais informações.$t(tracking.status.buyer.detail.TRACKING_N_CONTACT)`,
              FAILED_RETURN: `Seu pedido está retornando para o vendedor$t(tracking.status.buyer.detail.TRACKING_INFO)`,
              FAILED_AWAIT: `Tivemos um problema na entrega. Estamos analisando e logo traremos uma atualização.$t(tracking.status.buyer.detail.TRACKING_N_CONTACT)`,
            },
          } satisfies TRACKING_STATUS,
          actions: {
            generateLabel: 'Gerar etiqueta de envio',
          },
        },
        order: {
          details: 'Detalhes do pedido',
          date: 'Data do pedido',
          value: 'Valor do item',
        },
        help: 'Precisa de ajuda?',
        actions: {
          talkToUs: 'Fale com a gente',
          track: 'Rastrear envio',
        },
      },
    },
  },
}

export type RarumIntlShape = (typeof messages)['pt-BR']
export type AllRarumMessagesIntlShape = RarumIntlShape &
  typeof import('translate/languages/async/cvm88/pt')['default']['pt-BR']
export default messages
